<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <input v-model="filter.search" type="text" class="form-control" placeholder="Search...">
        </div>
      </div>
      <div class="col-md-6" />
      <div class="col-md-2">
        <button v-b-modal.form-modal class="btn btn-primary btn-block" @click="cleanUpForm()">
          Create
        </button>
      </div>
    </div>

    <b-card-code no-body>
      <div class="table-responsive-sm" style="overflow-x: auto">
        <table class="table b-table table-fixed">
          <thead>
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Toko</th>
              <th>URL</th>
              <th>Tanggal Mulai</th>
              <th>Tanggal Berakhir</th>
              <th>Target Wilayah</th>
              <th>Status</th>
              <th>Clicked</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr v-if="isLoading">
              <td colspan="5" class="text-center">
                <b-spinner label="Loading..." variant="primary" />
              </td>
            </tr>
            <tr v-for="item, index in result.data" v-if="!isLoading" :key="`table-${index}`">
              <td>
                <img :src="item.image_url" style="max-width: 50px; margin-right: 10px;">
              </td>
              <td>{{ item.title || '-' }}</td>
              <td>{{ item.merchant ? item.merchant.name : 'All Toko' }}</td>
              <td>{{ item.meta && item.meta.url || '-' }}</td>
              <td>{{ item.start_date && item.start_date || '-' }}</td>
              <td>{{ item.end_date && item.end_date || '-' }}</td>
              <td v-html="formatWilayah(item)"></td>
              <td v-html="formatStatus(item.ads_status)"></td>
              <td>
                <span
                    style="cursor: pointer; text-decoration: underline dotted; text-underline-offset: 3px; color: #007bff;"
                    @click="showClickDetail(item.id)"
                >
                    {{ item.click_counter }}
                </span>
              </td>
              <td class="text-right">
                <div class="btn-group" role="group" aria-label="Basic example">

                  <button class="btn btn-success btn-sm" style="margin-left: 2px;" data-toggle="tooltip"
                    data-placement="top" title="Up Position" @click="upPosition(item)">
                    <feather-icon icon="ArrowUpIcon" />
                  </button>

                  <button class="btn btn-success btn-sm" style="margin-left: 2px;" data-toggle="tooltip"
                    data-placement="top" title="Down Position" @click="downPosition(item)">
                    <feather-icon icon="ArrowDownIcon" />
                  </button>

                  <button class="btn btn-info btn-sm" style="margin-left: 2px;" data-toggle="tooltip"
                    data-placement="top" title="Edit" @click="editItem(item)">
                    <feather-icon icon="EditIcon" />
                  </button>

                  <button class="btn btn-sm" :class="(item.ads_status === 0 ) ? 'btn-primary' : 'btn-warning'" style="margin-left: 2px;" data-toggle="tooltip"
                    data-placement="top" :title="(item.ads_status === 0 ) ? 'Activate' : 'Deactive'" @click="changeStatusItem(item)">
                    <feather-icon :icon="(item.ads_status === 0 ) ? 'CheckIcon' : 'SlashIcon'" />
                  </button>

                  <button class="btn btn-danger btn-sm" style="margin-left: 2px;" data-toggle="tooltip"
                    data-placement="top" title="Delete" @click="deleteItem(item.id)">
                    <feather-icon icon="Trash2Icon" />
                  </button>

                </div>
              </td>
            </tr>
            <tr v-if="result.total == 0 && !isLoading">
              <td colspan="10" class="text-center">
                Data is empty.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row mt-1">
          <div class="col-6 pl-2">
            <small>Showing {{ result.from }} to {{ result.to }} from {{ result.total }}</small>
          </div>
          <div class="col-6 pr-2">
            <pagination :data="result" :limit="4" align="right" @pagination-change-page="getData" />
          </div>
        </div>
      </div>
    </b-card-code>

    <!-- Add/Edit Modal -->
    <b-modal id="form-modal" size="lg" :title="editId != null ? 'Edit' : 'Add'" :no-close-on-backdrop="true">

      <div class="form-group">
        <label for="">Image:</label><br>
        <input id="file" ref="file" type="file" accept="image/*" @change="changeImage">

        <div class="alert alert-info p-1 mt-1">
          <strong>Catatan</strong>
          <ul>
            <li>Maksimal ukuran file adalah 1MB</li>
            <li>Mohon gunakan gambar dengan aspek rasio 16:9 untuk tampilan lebih baik</li>
          </ul>
        </div>
      </div>

      <div class="form-group">
        <label for="">Title:</label>
        <input v-model="formPayload.title" type="text" class="form-control"
          :class="validations.hasOwnProperty('title') && validations.title.length > 0 ? 'is-invalid' : ''"
          placeholder="Title...">
        <small v-if="validations.hasOwnProperty('title') && validations.title.length > 0" class="text-danger">
          {{ validations.title.join(', ') }}
        </small>
      </div>

      <div class="form-group">
        <label for="merchant_uuid">Toko:</label>
        <v-select id="merchant_uuid" v-model="formPayload.merchant_uuid" :options="formData.merchants"
          :reduce="item => item.uuid" label="name" placeholder="Type to search Toko..." @search="onSearchMerchant">
          <template slot="no-options">
            Type here to search item...
          </template>
        </v-select>
        <small>Keep it empty if you want to show image on all Toko</small>
      </div>

      <div class="form-group">
        <label for="">URL:</label>
        <input v-model="formPayload.url" type="text" class="form-control"
          :class="validations.hasOwnProperty('url') && validations.url.length > 0 ? 'is-invalid' : ''"
          placeholder="URL...">
        <small v-if="validations.hasOwnProperty('url') && validations.url.length > 0" class="text-danger">
          {{ validations.url.join(', ') }}
        </small>
      </div>

      <div class="form-group">
        <b-row>
          <b-col cols="6">
            <label for="">Tanggal Mulai:</label>
            <input
              v-model="formPayload.start_date"
              type="date"
              class="form-control"
            />
          </b-col>
          <b-col cols="6">
            <label for="">Tanggal Berakhir:</label>
            <input
              v-model="formPayload.end_date"
              type="date"
              class="form-control"
            />
          </b-col>
        </b-row>
      </div>
      <div class="form-group">
          <label>Provinsi</label>
          <v-select
              v-model="formPayload.provinces_target"
              :options="provinceOptions"
              label="nama_provinsi"
              :reduce="p => p.id"
              placeholder="Pilih Provinsi"
              multiple
          />
      </div>
      <div class="form-group">
          <label>Kota/Kabupaten</label>
          <v-select
            v-model="formPayload.cities_target"
            :options="groupedCityOptions"
            label="label"
            :reduce="option => option.value"
            :selectable="option => !option.isHeader"
            placeholder="Pilih Kota/Kabupaten"
            multiple
          >
            <template #option="{ label, isHeader }">
              <div
                v-if="isHeader"
                style="
                  font-weight: 600;
                  color: #999;
                  pointer-events: none;
                  cursor: default;
                "
              >
                {{ label }}
              </div>

              <div v-else style="padding-left: 16px;">
                {{ label }}
              </div>
            </template>
          </v-select>
      </div>
      <div class="form-group">
        <label for="v-renewal">Status</label>
        <b-form-group>
            <b-form-select id="v-renewal" v-model="formPayload.ads_status" class="custom__input">
                <b-form-select-option value="0">Inactive</b-form-select-option>
                <b-form-select-option value="1">Active</b-form-select-option>
            </b-form-select>
        </b-form-group>
    </div>

      <template #modal-footer="{}">
        <div v-if="isLoading">
          <br>
          <b-spinner class="mb-2" variant="primary" /><br>
        </div>
        <b-button v-if="editId == null" variant="success" :disabled="isLoading" @click="createItem()">
          Save Item
        </b-button>
        <b-button v-else variant="success" :disabled="isLoading" @click="updateItem()">
          Save Item
        </b-button>
      </template>
    </b-modal>
    <!-- Add/Edit Modal -->

  </div>
</template>

<script>
import _ from 'lodash'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BButton, BSpinner, BRow, BCol, BFormGroup, BFormSelect, BFormSelectOption,
} from 'bootstrap-vue'
import { checkPermission, successNotification, errorNotification } from '@/auth/utils'
import Vue from 'vue'
import VuejsDialog from 'vuejs-dialog'
import FileSaver from 'file-saver'
import vSelect from 'vue-select'

import 'vuejs-dialog/dist/vuejs-dialog.min.css'

Vue.use(VuejsDialog)

export default {
  title() {
    return 'Ads Management'
  },
  components: {
    BRow,
    BCol,
    BButton,
    BCardCode,
    BSpinner,
    vSelect,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
  },
  watch: {
    filter: {
      handler: _.debounce(function () {
        this.getData()
      }, 300),
      deep: true,
    },
    'formPayload.provinces_target'(newVal, oldVal) {
      if (this.isEditing) return

      const removedProvinces = oldVal.filter(id => !newVal.includes(id))

      if (removedProvinces.length) {
        // Remove cities that belong to removed provinces
        this.formPayload.cities_target = this.formPayload.cities_target.filter(
          cityId => {
            const city = this.cityOptions.find(c => c.id === cityId)
            // keep city if its province is still selected
            return city && !removedProvinces.includes(city.provinsi_id)
          }
        )
      }

      if (newVal.length) {
        this.getCities()
      }
    },
  },
  setup(props) {
    return {
      checkPermission,
      successNotification,
      errorNotification,
    }
  },
  computed: {
    groupedCityOptions() {
      const result = []

      this.formPayload.provinces_target.forEach(provinceId => {
        const province = this.provinceOptions.find(
          p => p.id === provinceId,
        )

        if (!province) return

        // Province header
        result.push({
          label: province.nama_provinsi,
          value: null,
          isHeader: true,
        })

        // Cities under it
        this.cityOptions
          .filter(c => c.provinsi_id === province.id)
          .forEach(city => {
            result.push({
              label: city.nama_kabkot,
              value: city.id,
              isHeader: false,
            })
          })
      })

      return result
    },
  },
  data() {
    return {
      currentPage: 1,
      result: {},
      isLoading: false,
      isLoadingImport: false,
      isLoadingExort: false,
      provinceOptions: [],
      cityOptions: [],
      cityLoading: false,
      isEditing: false,
      formPayload: {
        title: '',
        image: '',
        merchant_uuid: '',
        start_date: '',
        end_date: '',
        provinces_target: [],
        cities_target: [],
        ads_status: 0,
      },
      detail: null,
      editId: null,
      filter: {
        search: '',
      },
      importPayload: {
        file: null,
      },
      formData: {
        merchants: [],
      },
      validations: {},
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    this.getProvinces()
  },
  methods: {
    formatWilayah(item) {
      const provinces = item.provinces_target || []
      const cities = item.cities_target || []

      if (!provinces.length) {
        return '<strong>Seluruh Provinsi & Kota/Kabupaten</strong>'
      }

      return provinces
        .map(province => {
          const provinceCities = cities
            .filter(city => city.provinsi_id === province.id)
            .map(city => city.nama_kabkot)

          return `<strong>${province.nama_provinsi}</strong>: ${
            provinceCities.length ? provinceCities.join(', ') : 'Seluruh Kota/Kabupaten'
          }`
        })
        .join('<br>')
    },
    formatStatus(status) {
      const statusClass = {
        0: 'status-pill canceled',
        1: 'status-pill success',
      }[status] || 'status-pill'

      const label = {
        0: 'Inactive',
        1: 'Active',
      }[status] || '-'

      return `<span class="${statusClass}">${label}</span>`
    },
    upPosition(item) {
      this.$http.post(`/super-admin/image/${item.id}/up-position`)
        .then(response => {
          this.getData(this.currentPage)
          successNotification(this, 'Success', 'Item successfully updated!')
        })
        .catch(error => {
          if (error.response.data.meta.messages.length > 0) {
            errorNotification(this, 'Oops!', error.response.data.meta.messages)
          }
        })
    },
    downPosition(item) {
      this.$http.post(`/super-admin/image/${item.id}/down-position`)
        .then(response => {
          this.getData(this.currentPage)
          successNotification(this, 'Success', 'Item successfully updated!')
        })
        .catch(error => {
          if (error.response.data.meta.messages.length > 0) {
            errorNotification(this, 'Oops!', error.response.data.meta.messages)
          }
        })
    },
    onSearchMerchant(search, loading) {
      if (search.length) {
        loading(true)
        this.searchMerchant(loading, search, this)
      }
    },
    searchMerchant: _.debounce((loading, search, vm) => {
      vm.$http.get(`super-admin/merchant?per_page=10&search=${encodeURI(search)}`)
        .then(response => {
          vm.formData.merchants = response.data.data.data.map(obj => ({
            uuid: obj.uuid,
            name: obj.name,
          }))
        })
        .catch(error => {
          console.error(error)
        })
      loading(false)
    }, 300),
    changeImage(event) {
      // eslint-disable-next-line prefer-destructuring
      // this.formPayload.image = this.$refs.file.files[0]

      const target = event.target
      if (target.files && target.files[0]) {
        const maxAllowedSize = 1 * 1024 * 1024;
        if (target.files[0].size > maxAllowedSize) {
          errorNotification(this, 'Oops!', 'Ukuran file terlalu besar!')
          target.value = ''
          this.formPayload.image = ''
        } else {
          this.formPayload.image = target.files[0]
        }
      }
    },
    async getProvinces() {
      try {
          const res = await this.$http.post('/regions/provinces')
          this.provinceOptions = res.data.data || []
      } catch (err) {
          console.log('error provinsi: ', err)
      }
    },
    searchCity: _.debounce(function (search) {
      this.getCities(search)
    }, 400),
    async getCities(search = '') {
      if (!this.formPayload.provinces_target.length) return

      this.cityLoading = true

      try {
          const res = await this.$http.post('/regions/cities', {
              province_id: this.formPayload.provinces_target,
              search: search,
          })

          const newCities = res.data.data || []
          const existingIds = this.cityOptions.map(c => c.id)
          this.cityOptions = [
            ...this.cityOptions,
            ...newCities.filter(c => !existingIds.includes(c.id)),
          ]
      } catch (err) {
          console.log(err)
      } finally {
          this.cityLoading = false
      }
    },
    validateDates() {
      const { start_date, end_date } = this.formPayload

      if (start_date && end_date) {
        if (new Date(end_date) < new Date(start_date)) {
          errorNotification(
            this,
            'Validation Error',
            'Tanggal berakhir tidak boleh lebih kecil dari tanggal mulai',
          )
          return false
        }
      }

      return true
    },
    cleanUpForm() {
      this.editId = null
      this.formPayload = {
        title: '',
        image: '',
        merchant_uuid: '',
        start_date: '',
        end_date: '',
        provinces_target: [],
        cities_target: [],
        ads_status: 0,
      }
    },
    getData(page = 1) {
      this.isLoading = true
      this.currentPage = page
      const queryParams = this.filter
      queryParams.page = this.currentPage

      this.$http.get('/super-admin/image', {
        params: queryParams,
      })
        .then(response => {
          this.result = response.data.data
          this.isLoading = false
        })
    },
    createItem() {
      if (!this.validateDates()) {
        return
      }

      const form = this.preparePayload()

      this.$http.post('/super-admin/image', form, {
        headers: { 'content-type': 'multipart/form-data' },
      })
        .then(response => {
          this.$bvModal.hide('form-modal')
          this.getData(this.currentPage)
          successNotification(this, 'Success', 'Item successfully created')
          this.cleanUpForm()
        })
        .catch(error => {
          if (error.response.data.meta.messages.length > 0) {
            errorNotification(this, 'Oops!', error.response.data.meta.messages)
          }
        })
    },
    updateItem() {
      const form = this.preparePayload()
      form.append('_method', 'PATCH')

      this.$http.post(`/super-admin/image/${this.editId}`, form, {
        headers: { 'content-type': 'multipart/form-data' },
      })
        .then(response => {
          this.$bvModal.hide('form-modal')
          this.getData(this.currentPage)
          successNotification(this, 'Success', 'Item successfully updated!')
          this.cleanUpForm()
        })
        .catch(error => {
          if (error.response.data.meta.messages.length > 0) {
            errorNotification(this, 'Oops!', error.response.data.meta.messages)
          }
        })
    },
    preparePayload() {
      const form = new FormData()

      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.formPayload) {
        if (this.formPayload.hasOwnProperty(key) && this.formPayload[key] != null) {
          // Handle if this.formPayload[key] is array
          if (Array.isArray(this.formPayload[key])) {
            this.formPayload[key].forEach(value => form.append(`${key}[]`, value))
          } else {
            form.append(key, this.formPayload[key])
          }
          // form.append(key, this.formPayload[key])
        }
      }

      return form
    },
    async editItem(item) {
      this.editId = item.id
      this.isEditing = true

      this.formPayload = {
        title: item.title || '',
        image: '',
        merchant_uuid: item.merchant_uuid || '',
        url: item.meta?.url || '',
        start_date: item.start_date || '',
        end_date: item.end_date || '',
        provinces_target: (item.provinces_target || []).map(p => p.id),
        cities_target: (item.cities_target || []).map(c => c.id),
        ads_status: item.ads_status ?? 0,
      }

      await this.getCities()
      this.isEditing = false

      this.$bvModal.show('form-modal')
    },
    changeStatusItem(item) {
      const popupText = item.ads_status === 0 ? 'Are you sure to activate this item?' : 'Are you sure to deactivate this item?'
      const type = item.ads_status === 0 ? 'activate' : 'deactivate'
      this.$swal({
        title: 'Are you sure?',
        text: popupText,
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$http.post(`super-admin/ads/${type}`, { image_id: item.id }).then(response => {
            this.getData(this.currentPage)
            this.$swal({
              icon: 'success',
              title: 'Success!',
              text: `Item successfully ${type}`,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          })
          .catch(error => {
            if (error.response.data.meta.messages.length > 0) {
              errorNotification(this, 'Oops!', error.response.data.meta.messages)
            }
          })
        }
      })
    },
    deleteItem(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'Are you sure to delete this item?',
        icon: 'warning',
        showCancelButton: true,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$http.delete(`super-admin/image/${id}`)
            .then(response => {
              this.getData(this.currentPage)
              this.$swal({
                icon: 'success',
                title: 'Success!',
                text: 'Item successfully deleted',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
            .catch(error => {
              if (error.response.data.meta.messages.length > 0) {
                errorNotification(this, 'Oops!', error.response.data.meta.messages)
              }
            })
        }
      })
    },
    showClickDetail(id) {
      this.$router.push({ name: 'adsmanagement.detail', params: { id: id } })
    }
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .status-pill {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    border-radius: 999px;
    color: white;
    font-weight: 500;
    text-transform: capitalize;
    font-size: 0.875rem;
  }

  .status-pill.canceled {
    background-color: #dc3545; // red
  }

  .status-pill.success {
    background-color: #28a745; // green
  }
</style>
